import * as React from 'react';
import * as style from './CompanyLabel.css';

export const CompanyLabel: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={style['company-label']}>{children}</div>;
};
